import React, { FC } from 'react';

import { DropDownOptions } from 'devextreme-react/cjs/autocomplete';
import { RequiredRule } from 'devextreme-react/cjs/data-grid';

import AppFiledBox from 'components/appComponents/app-field-box';
import { SelectBox, Validator } from 'devextreme-react';

import { PaymentMethod } from 'bus/contractorNomenclaturePrice/types';
import { PricesItem } from 'bus/request/types';

type Props = {
  value: PaymentMethod | null;
  onChange: (paymentMethod: PaymentMethod, price: number) => void;
  pricesDataList?: PricesItem[];
};

export const PaymentMethodSelect: FC<Props> = ({ value, pricesDataList, onChange }) => {
  return (
    <AppFiledBox label="Способ оплаты*" labelTop>
      <SelectBox
        stylingMode="underlined"
        items={pricesDataList}
        displayExpr="name"
        valueExpr="paymentMethod"
        value={value}
        onItemClick={(e) => {
          onChange(e.itemData.paymentMethod, e.itemData.price);
        }}
      >
        <DropDownOptions title="Выберите способ оплаты" closeOnOutsideClick={true} showTitle={false} />
        <Validator>
          <RequiredRule message="Выберите способ оплаты" />
        </Validator>
      </SelectBox>
    </AppFiledBox>
  );
};
